import React from 'react';
import getCookies from 'commons/getCookies';
import PDPKeySellingPointsV1 from './PDPKeySellingPointsV1';
import PDPKeySellingPointsV2 from './PDPKeySellingPointsV2';

const KSP_V2_KEY = 'v2_ksp';

const PDPKeySellingPoints = () => {
  const [useV2, setUseV2] = React.useState(false);

  React.useEffect(() => {
    const value = getCookies()?.get(KSP_V2_KEY);
    if (value && String(value).trim() === 'true') {
      setUseV2(true);
    }
  }, []);

  if (useV2) {
    return <PDPKeySellingPointsV2 />;
  }

  return <PDPKeySellingPointsV1 />;
};

export default PDPKeySellingPoints;
